module.exports = __webpack_public_path__ + "media/img/wedding_success/broadcast-5d2117b44d7099b0eb29e0d05fccdc52.png";